
import { mdlPremiumCovers } from "./mdlPremiumCovers";
import { mdlAdditionalCovers } from "./mdlAdditionalCovers";


export class mdlCheckEligibilityRes {

    public BASIC_PREMIUM: number;
    public TOTAL_AMOUNT_BEFORE_VAT_COMP: number;
    public VAT_AMOUNT_COMP: number;
    public TOTAL_AMOUNT_COMP: number;
    public TOTAL_REFUND_AMOUNT_TPL: number;
    public TOTAL_AMOUNT_UPGRADE: number;
    public ADDITIONAL_COVERS: Array<mdlAdditionalCovers> = new Array<mdlAdditionalCovers>();
    public STATUS_CODE: string;
    public ERROR_MSG: string;
    public CoverDetails: Array<mdlPremiumCovers> = new Array<mdlPremiumCovers>();
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlCheckEligibilityRes.ts